import { render } from "./Industries.vue?vue&type=template&id=2fffb2fe&scoped=true"
import script from "./Industries.vue?vue&type=script&lang=js"
export * from "./Industries.vue?vue&type=script&lang=js"

import "./Industries.vue?vue&type=style&index=0&id=2fffb2fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fffb2fe"]])

export default __exports__